export default __webpack_public_path__ + "static/media/language_speech.f666c45d.jpg";